module.exports = __webpack_public_path__ + "media/images/icon__arrow-right--rb-light-gray@2x-91b8ac8fb61a3cec1dc4e6b8815ef29c.png";